import { BigDecimal, LogisticaTiposEntrega } from "@pcgerente-node/pcg-comun";
import { logistica_GUIA_PROFORMA, logistica_GUIA_PROFORMA_DETALLE } from "@pcgerente-node/pcg-comun/dist/DTOs";
import axios, { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import img1 from "../../../assets/img/Recurso 3.png";
import { clearInfoDestinatario, clearInfoRemitente, clearProductosDisponibles, getAllCities, saveGuiaPrevisualizar } from "../../../redux/actions/actionsCrear";
import { baseURL, headers } from "../../../redux/helpersRedux";
import { RootState, useAppDispatch } from "../../../redux/store";
import {IApiResponse} from "@pcgerente-node/pcg-comun";
import { logistica_GUIA_PROFORMALocal } from "../../Entidades/logistica_GUIA_PROFORMA";
import { StyleProps, StyleProps1, StyleProps10, StyleProps11, StyleProps12, StyleProps13, StyleProps14, StyleProps15, StyleProps16, StyleProps1_1, StyleProps2, StyleProps3, StyleProps4, StyleProps5, StyleProps6, StyleProps7, StyleProps8, StyleProps9 } from "./styles";


const PrevisualizarContent = () => {

    const infoGuiaStore = useSelector((state: RootState) => state.crear.guiaPrevisualizar);
    const ciudadesStore = useSelector((state: RootState) => state.crear.ciudadesCrear);
    const usuarioActual = useSelector((state: RootState) => state.auth.usuarioActual);
    const [guiaProforma, setGuiaProforma] = useState(new logistica_GUIA_PROFORMALocal())

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(getAllCities())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (infoGuiaStore?.loading== false) {
            setGuiaProforma(infoGuiaStore.info)
        }
    }, [infoGuiaStore])

    const [error, setError] = useState("")

    const handleEditar = () => {
        dispatch(saveGuiaPrevisualizar(guiaProforma))
        navigate("/home/crear/guia")
    }

    const handleGuardar = async () => {
        const btnGuardar = window.document.getElementById('btnGuardar') as HTMLButtonElement | null;
        const btnEditar = window.document.getElementById('btnEditar') as HTMLButtonElement | null;

        if (btnGuardar && btnEditar) {
            btnGuardar.disabled = true
            btnEditar.disabled = true
        }

        const resultado = await intentarSubirGuia(guiaProforma)
        if (!resultado.includes("Error")) { // si nos devuelve un id
            navigate(`/home/crear/imprimir/${resultado}`)
        } else { //error
            setError(resultado)
        }

        if (btnGuardar && btnEditar) {
            btnGuardar.disabled = false
            btnEditar.disabled = false
        }
    }

    return (
        <div id="content" className="main-content">
            <div className="layout-px-spacing">
                <div className="row invoice layout-top-spacing layout-spacing">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">

                        <div className="doc-container">

                            <div className="row">

                                <div className="col-xl-12">

                                    <div className="invoice-container">
                                        <div className="invoice-inbox">

                                            <div id="ct" className="">

                                                <div className="invoice-00001">
                                                    <div className="content-section">

                                                        <div className="inv--head-section inv--detail-section">

                                                            <div className="row" style={StyleProps}>
                                                                <div className="col-sm-4 mt-1 text-center d-flex justify-content-center">

                                                                    <img className="company-logo mr-4" src={img1} alt="company" width="40" height="40" />


                                                                    <table style={StyleProps1}>
                                                                        <tbody>

                                                                            <tr>
                                                                                <th scope="row" abbr="Guayaquil">Guayaquil:</th>
                                                                                <td>043906260 </td>

                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="row" abbr="Quito">Quito:</th>
                                                                                <td>022800244 </td>

                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="row" abbr="Sto. Domingo:">Sto. Domingo:</th>
                                                                                <td>0994190159 </td>

                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="row" abbr="Machala:">Machala:</th>
                                                                                <td>0992798033 </td>

                                                                            </tr>
                                                                            <tr>
                                                                                <th scope="row" abbr="Ambato:">Ambato:</th>
                                                                                <td>0985796250 </td>

                                                                            </tr>
                                                                        </tbody>

                                                                    </table>




                                                                </div>

                                                                <div className="col-sm-4 text text-center">

                                                                    <div className=" " style={StyleProps1_1}>Operadora Logística del Ecuador Exactocarga</div>
                                                                    <div className=" " style={StyleProps1_1}>RUC:0993108766001</div>
                                                                    <div className=" " style={StyleProps1_1}>www.exactocarga.com</div>
                                                                </div>

                                                                <div className="col-sm-4 mt-1 text align-self-center">

                                                                    <div style={StyleProps2}>
                                                                        <table>
                                                                            <tbody>

                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Guía">Guía:</th>
                                                                                    <td>{`${guiaProforma.serie1}-${guiaProforma.serie2}-${guiaProforma.numeroDocumento}`} </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Fecha de Envio">Fecha de Envio:</th>
                                                                                    <td>{guiaProforma.fechaEmision?.toLocaleDateString()}</td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Origen:">Origen:</th>
                                                                                    <td>
                                                                                        {ciudadesStore?.info?.filter(c => c.id === guiaProforma.idCiudadOrigen)[0]?.nombre ||
                                                                                            ciudadesStore?.info?.filter(c => c.id === guiaProforma.CLIENTE_REMITENTE?.ciudad)[0]?.nombre
                                                                                            || ""}
                                                                                    </td>

                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Destino:">Destino:</th>
                                                                                    <td>{ciudadesStore?.info?.filter(c => c.id === guiaProforma.idCiudadDestino)[0]?.nombre ||
                                                                                        ciudadesStore?.info?.filter(c => c.id === guiaProforma.CLIENTE_DESTINATARIO?.ciudad)[0]?.nombre}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>

                                                                <div className="col-sm-6 text-center mt-6 pt-2">
                                                                    <div style={StyleProps4}>Remitente</div>
                                                                    <div style={StyleProps5}>

                                                                        <table>
                                                                            <tbody>

                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Razon Social">Razon Social:</th>
                                                                                    <td>{guiaProforma.CLIENTE_REMITENTE?.razonSocial}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Ruc/CI">Ruc/CI:</th>
                                                                                    <td>{guiaProforma.CLIENTE_REMITENTE?.cedula} </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Teléfono:">Teléfono:</th>
                                                                                    <td>{guiaProforma.CLIENTE_REMITENTE?.telefono} </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Dirección:">Dirección:</th>
                                                                                    <td>{guiaProforma.CLIENTE_REMITENTE?.direccion} </td>
                                                                                </tr>
                                                                            </tbody>

                                                                        </table>
                                                                    </div>
                                                                </div>
                                                                <div className="col-sm-6 text-center mt-6 pt-2">
                                                                    <div style={StyleProps4}>Destinatario</div>
                                                                    <div style={StyleProps5}>
                                                                        <table>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Razon Social">Razon Social:</th>
                                                                                    <td>{guiaProforma.CLIENTE_DESTINATARIO?.razonSocial}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Ruc/CI">Ruc/CI:</th>
                                                                                    <td>{guiaProforma.CLIENTE_DESTINATARIO?.cedula} </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Teléfono:">Teléfono:</th>
                                                                                    <td>{guiaProforma.CLIENTE_DESTINATARIO?.telefono}</td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th style={StyleProps3} scope="row" abbr="Dirección:">Dirección:</th>
                                                                                    <td>{guiaProforma.direccionDestinatario}</td>
                                                                                </tr>
                                                                            </tbody>

                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <p className=""></p>


                                                        <div className="inv--product-table-section">
                                                            <div className="table-responsive">
                                                                <table className="table">
                                                                    <thead className="">
                                                                        <tr style={StyleProps7}>
                                                                            <th style={StyleProps6} scope="col">Bulto</th>
                                                                            <th style={StyleProps6} scope="col">Contenido</th>
                                                                            <th style={StyleProps6} scope="col">Detalles</th>
                                                                            <th style={StyleProps6} scope="col">Cantidad</th>
                                                                            <th style={StyleProps6} scope="col">Precio</th>
                                                                            <th style={StyleProps6} scope="col">Total</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>

                                                                        {
                                                                            guiaProforma.rowsContenidoParaCrear.filter(el => el.descripcion).map((child, i) =>
                                                                                <tr style={StyleProps8} key={i}>
                                                                                    <td className="text-left;">{child.bultos}</td>
                                                                                    <td className="text-left">{child.descripcion}</td>
                                                                                    <td className="text-left">{child.detalles}</td>
                                                                                    <td className="text-left">{new BigDecimal(child.cantidad).toString()}</td>
                                                                                    <td className="text-left">${new BigDecimal(child.precio).toString()}</td>
                                                                                    <td className="text-left">${new BigDecimal(child.total).toString()}</td>
                                                                                </tr>
                                                                            )
                                                                        }
                                                                        <tr>
                                                                            <td style={StyleProps9}>{guiaProforma.rowsContenidoParaCrear.reduce((acum,x) => acum += x.bultos,0)}</td>
                                                                            <td className="text-center" style={StyleProps10}>← TOTAL BULTOS</td>

                                                                            <td className="text-right"></td>
                                                                            <td className="text-center" style={StyleProps11}> TOTAL USD →</td>
                                                                            <td style={StyleProps9}>${new BigDecimal(guiaProforma.total).toString()}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                                <div className="inv--note">
                                                                    <div className="">

                                                                        <div className="inv--product-table-section">
                                                                            <div className="table-responsive">
                                                                                <table className="table border=solid 5px" style={StyleProps12}>
                                                                                    <thead className="">
                                                                                        <tr style={StyleProps3}>
                                                                                            <th style={StyleProps13} scope="col">FORMA DE PAGO</th>
                                                                                            <th style={StyleProps13} scope="col">TIPO DE ENTREGA</th>
                                                                                            <th style={StyleProps13} scope="col">FECHA DE EMISION</th>
                                                                                            <th style={StyleProps13} scope="col">#GUIA</th>
                                                                                            <th style={StyleProps13} scope="col">ELABORADA POR</th>
                                                                                            <th style={StyleProps13} scope="col">OBSERVACIONES</th>

                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody className="table border=solid 5px" style={StyleProps14} >
                                                                                        <tr>
                                                                                            <td style={StyleProps15} className="text-left">Crédito</td>
                                                                                            <td style={StyleProps16} className="text-left">{guiaProforma.tipoEntrega === LogisticaTiposEntrega.Domicilio ? "A Domicilio" : "Retiro en Oficina"}</td>
                                                                                            <td style={StyleProps16} className="text-left">{"No emitida aún"}</td>
                                                                                            <td style={StyleProps16} className="text-left">{`${guiaProforma.serie1}-${guiaProforma.serie2}-${guiaProforma.numeroDocumento}`}</td>
                                                                                            <td style={StyleProps16} className="text-left">{usuarioActual?._ItemActivo.usuario || ""}</td>
                                                                                            <td style={StyleProps16} className="text-left">{guiaProforma.observacion}</td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                            <div className="invoice-action-btn">
                                <div className="row">
                                    <div className="col-md-6 col-sm-6 text-center pt-2">
                                        <button className="btn btn-primary btn-send" id="btnGuardar" onClick={() => handleGuardar()}>Guardar </button>
                                    </div>

                                    <div className="col-md-6 col-sm-6 text-center pt-2">
                                        <button className="btn btn-dark btn-edit" id="btnEditar" onClick={() => handleEditar()}>Editar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="text-danger mt-4">{error}</span>
                        <div className="footer-wrapper">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

    async function intentarSubirGuia(gp: logistica_GUIA_PROFORMALocal): Promise<string> {
        let retorno = ""
        let detalles:  logistica_GUIA_PROFORMA_DETALLE[] = []
        let seguro = new BigDecimal()
        let ivaSeguro = new BigDecimal()
        for (let d of guiaProforma.rowsContenidoParaCrear) {
            const _det = new logistica_GUIA_PROFORMA_DETALLE()
            _det.id = undefined
            _det.idGuiaProforma = undefined
            _det.idContenido = d.idContenido
            _det.cantidad =  d.cantidad ;
            _det.detalle= d.detalles;
            _det.precio= d.precio.toDecimalPlaces(2, BigDecimal.ROUND_UP);
            _det.total= d.total.toDecimalPlaces(2, BigDecimal.ROUND_UP);
            _det.subtotal = d.subtotal.toDecimalPlaces(2, BigDecimal.ROUND_UP);
            _det.iva = d.iva.toDecimalPlaces(2, BigDecimal.ROUND_UP);
            _det.seguro = d.seguro;
            _det.bultos = d.bultos;
            if(d.seguro){
                seguro = new BigDecimal(d.subtotal.toDecimalPlaces(2, BigDecimal.ROUND_UP))
                ivaSeguro = new BigDecimal(d.iva.round())
            }
            if(d.idContenido){
                detalles.push(_det)
            }
        }
        const guiaProformaAEnviar: logistica_GUIA_PROFORMA = {
            ...gp,
            id: undefined,
            idUsuario: usuarioActual._ItemActivo.id,
            LS_usuarioCreacion: usuarioActual._ItemActivo.usuario,
            fechaEmision: new Date(),
            logistica_GUIA_PROFORMA_DETALLE: detalles,
            seguro,
            ivaSeguro,
            bultos: detalles.reduce((acum,x) => acum = acum.plus(x.bultos),new BigDecimal(0)),
            cantidad: detalles.reduce((acum,x) => acum = acum.plus(x.cantidad),new BigDecimal(0))
        }

        const post = await axios.post(`${baseURL}logistica_GUIA_PROFORMA`, guiaProformaAEnviar, headers)
            .then((el: AxiosResponse<IApiResponse<logistica_GUIA_PROFORMA>>) => el.data)

        if (post.error) {
            retorno = `Error: ${post.error}`
        } else {
            await dispatch(clearInfoRemitente())
            await dispatch(clearInfoDestinatario())
            await dispatch(clearProductosDisponibles())
            retorno = `${post.companion?.serie1}-${post.companion?.serie2}-${post.companion?.numeroDocumento}`
        }
        return retorno
    }

}


export default PrevisualizarContent